import { render } from "./PlatRoleComponent.vue?vue&type=template&id=da2810ca&scoped=true"
import script from "./PlatRoleComponent.vue?vue&type=script&lang=js"
export * from "./PlatRoleComponent.vue?vue&type=script&lang=js"

import "./PlatRoleComponent.vue?vue&type=style&index=0&id=da2810ca&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da2810ca"]])

export default __exports__